


  const dropdown = document.getElementById('acv-ul');
  const selectedNav = document.getElementById('selectedNav');

  const acvState = {
    selectedMake: '',
  };
  let autoFocusedFirst = false;

  const fetchData = async (url) => {
    try {
      const response = await fetch(url, { mode: 'cors' });
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch data', error);
    }
  };

  const appendLiGroups = (el, groupTitle, arr, type, liClass) => {
    if (!arr.length) return;

    const headLi = document.createElement('li');
    headLi.textContent = groupTitle;
    headLi.classList.add('li-head');
    el.appendChild(headLi);

    // makes are strings, models are { model, handle } (assets/pc-vehicle-data.js)
    const sorted = type === 'model'
      ? [...arr].sort((a, b) => PCVehicleData.collator.compare(a.model, b.model))
      : [...arr].sort((a, b) => PCVehicleData.collator.compare(a, b));
    sorted.forEach((each) => {
      const li = document.createElement('li');
      li.dataset.type = type;
      li.dataset.value = type === 'model' ? each.handle : each;
      li.classList.add(liClass);

      if (type === 'model') {
        li.textContent = each.model;

        const product = findProductByHandle(each.handle);
        if (product) {
          const ratingSpan = document.createElement('span');
          ratingSpan.className = 'loox-rating';
          ratingSpan.setAttribute('data-id', product.id);
          ratingSpan.setAttribute('data-rating', product.rating);
          ratingSpan.setAttribute('data-raters', product.reviews);
          li.appendChild(ratingSpan);
        }
      } else {
        li.textContent = each;
      }

      el.appendChild(li);
    });
  };

  const handleMakeSelection = () => {
    const makeElements = document.querySelectorAll('.li-make');
    makeElements.forEach((li) => {
      li.addEventListener('click', (e) => {
        dropdown.innerHTML = '';
        const selectedMake = e.currentTarget.dataset.value;
        acvState.selectedMake = selectedMake;

        const modelList = getModelsByMake(selectedMake);
        const { bestSellers, others } = splitByBestSellers(modelList, getAllBestSellerModels());

        appendLiGroups(dropdown, `Best Sellers`, bestSellers, 'model', 'li-model');
        appendLiGroups(dropdown, `Models`, others, 'model', 'li-model');
        selectedNav.style.display = "block";
        selectedNav.innerHTML = `<div>
          <span>Selected Make:</span>
          <span>${selectedMake}</span>
        </div>`
        
        handleModelSelection();
        document.getElementById('acv-back-button').dataset.back = "makeBack"
        
        dropdown.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

      });
    });
  };

  const handleModelSelection = () => {
    const modelElements = document.querySelectorAll('.li-model');
    modelElements.forEach((li) => {
      li.addEventListener('click', (e) => {

      document.getElementById('acv-back-button').dataset.back = "initial"; 
      dropdown.style.pointerEvents = "none";

        const spinnerHTML = `
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke="#fc3" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `;

        e.target.insertAdjacentHTML("beforeend", spinnerHTML);




        window.location.href = PCVehicleData.productUrl(e.currentTarget.dataset.value);
      });
    });
  };

  const getModelsByMake = (make) => {
    const match = window.makeModelData.find((item) => item.make === make);
    return match ? match.models : [];
  };

  // Best seller product handles (categorized-banner collections)
  const getAllBestSellerModels = () => {
    const bestSellerModels = new Set();
    window.collectionProductList.forEach((group) => {
      group.products.forEach((product) => {
        bestSellerModels.add(product.handle);
      });
    });
    return bestSellerModels;
  };

  const splitByBestSellers = (list, bestSet) => {
    const bestSellers = [];
    const others = [];

    list.forEach((item) => {
      if (bestSet.has(item.handle)) {
        bestSellers.push(item);
      } else {
        others.push(item);
      }
    });

    return { bestSellers, others };
  };

  const findProductByHandle = (handle) => {
    for (const group of window.collectionProductList) {
      const match = group.products.find((p) => p.handle === handle);
      if (match) return match;
    }
    return null;
  };

const selectorACV = document.querySelector('.selector-collection.selector-acv');

if (selectorACV) {
  selectorACV.addEventListener('click', async () => {
    // Vehicle list of the visitor's market (assets/pc-vehicle-data.js) — spinner until it arrives
    const searchInput = document.getElementById('acv-search');
    if (!window.makeModelData) {
      dropdown.replaceChildren(PCVehicleData.loadingItem());
      searchInput.disabled = true;
    }
    const data = await PCVehicleData.load().catch((error) => {
      console.error('Failed to fetch data', error);
    });
    searchInput.disabled = false;

    if (!data || !window.collectionProductList) {
      dropdown.innerHTML = '';
      return;
    }

    window.makeModelData = data;

    const allMakesSet = new Set(data.map((item) => item.make));
    const bestSellerMakesSet = getAllBestSellerMakes();

    const bestSellerMakes = [];
    const normalMakes = [];

    allMakesSet.forEach((make) => {
      if (bestSellerMakesSet.has(make)) {
        bestSellerMakes.push(make);
      } else {
        normalMakes.push(make);
      }
    });

    dropdown.innerHTML = '';

    appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
    appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');

    handleMakeSelection();
    handleSearch();
    handleKeyboardNavigation();
  });
}







const handleSearch = () => {
  const input = document.getElementById('acv-search');
  input.addEventListener('input', (e) => {
    const query = e.target.value.trim().toLowerCase();
    dropdown.innerHTML = '';

    if (!query) {
      acvState.selectedMake = '';

      const allMakes = window.makeModelData.map(entry => entry.make);
      const uniqueMakes = [...new Set(allMakes)];

      const bestSellerMakes = [];
      const normalMakes = [];

      uniqueMakes.forEach((make) => {
        if (getAllBestSellerMakes().has(make)) {
          bestSellerMakes.push(make);
        } else {
          normalMakes.push(make);
        }
      });

      appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
      appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
      handleMakeSelection();
      return;
    }

    let foundSomething = false;

    if (acvState.selectedMake) {
      const modelMatches = getMatchedModels(query);
      if (modelMatches.length) {
        appendSearchResults('Models', modelMatches, 'model', 'li-model', query);
        foundSomething = true;
      }
    } else {
      const makeMatches = getMatchedMakes(query);
      const modelMatches = getMatchedModels(query);

      if (makeMatches.length) {
        appendSearchResults('Makes', makeMatches, 'make', 'li-make', query);
        foundSomething = true;
      }

      if (modelMatches.length) {
        appendSearchResults('Models', modelMatches, 'model', 'li-model', query);
        foundSomething = true;
      }
    }

    attachSearchResultHandlers();


    // focus first item only first time
    autoFocusedFirst = false;
    setTimeout(() => {
      if (!autoFocusedFirst) {
        const items = dropdown.querySelectorAll('li.li-make, li.li-model');
        if (items.length > 0) {
          focusedIndex = 0;
          updateFocus(items, focusedIndex);
          autoFocusedFirst = true;
        }
      }
    }, 0);

  if (!foundSomething) {
      const li = document.createElement('li');
      li.textContent = 'No results found.';
      li.style.color = 'gray';
      li.style.padding = '10px';
      dropdown.appendChild(li);
    }

  










  });
};



const getAllBestSellerMakes = () => {
  if (window.bestSellerMakeSet) return window.bestSellerMakeSet;

  // Makes that have at least one best seller product
  const bestHandles = getAllBestSellerModels();
  const bestSellerMakes = new Set(
    window.makeModelData
      .filter((entry) => entry.models.some((m) => bestHandles.has(m.handle)))
      .map((entry) => entry.make)
  );

  window.bestSellerMakeSet = bestSellerMakes; // for performance 
  return bestSellerMakes;
};




const getMatchedMakes = (query) => {
  return window.makeModelData
    .map((entry) => entry.make)
    .filter((make, i, arr) => arr.indexOf(make) === i && make.toLowerCase().includes(query));
};

const getMatchedModels = (query) => {
  const scope = acvState.selectedMake
    ? window.makeModelData.filter((item) => item.make === acvState.selectedMake)
    : window.makeModelData;

  // matched and shown as "Make Model"
  return scope
    .flatMap((entry) => entry.models.map((m) => ({ ...m, label: `${entry.make} ${m.model}` })))
    .filter((m) => m.label.toLowerCase().includes(query));
};

const highlightMatch = (text, query) => {
  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<span style="color:red;">$1</span>');
};

const appendSearchResults = (title, list, type, className, query) => {
  if (!list.length) return;

  const headLi = document.createElement('li');
  headLi.textContent = title;
  headLi.classList.add('li-head');
  dropdown.appendChild(headLi);

  const regex = new RegExp(`(${query})`, 'gi');

  list.forEach((item) => {
    const li = document.createElement('li');
    li.dataset.type = type;
    li.dataset.value = type === 'model' ? item.handle : item;
    li.classList.add(className);

    const parts = (type === 'model' ? item.label : item).split(regex);
    parts.forEach((part) => {
      const span = document.createElement('span');
      span.textContent = part;
      if (part.toLowerCase() === query.toLowerCase()) {
        span.style.color = 'red';
      }
      li.appendChild(span);
    });

    dropdown.appendChild(li);
  });
};


const attachSearchResultHandlers = () => {
  const makeEls = document.querySelectorAll('.li-make');
  const modelEls = document.querySelectorAll('.li-model');

  makeEls.forEach((li) => {
    li.addEventListener('click', () => {
      document.getElementById('acv-back-button').dataset.back = "initial"; 
      const selectedMake = li.dataset.value;
      acvState.selectedMake = selectedMake;

      const modelList = getModelsByMake(selectedMake);
      const { bestSellers, others } = splitByBestSellers(modelList, getAllBestSellerModels());

      dropdown.innerHTML = '';
      appendLiGroups(dropdown, `Best Sellers`, bestSellers, 'model', 'li-model');
      appendLiGroups(dropdown, `Models`, others, 'model', 'li-model');
              selectedNav.style.display = "block";
        selectedNav.innerHTML = `<div>
          <span>Selected Make:</span>
          <span>${selectedMake}</span>
        </div>`

      handleModelSelection();
      document.getElementById('acv-search').value = '';

      document.getElementById('acv-back-button').dataset.back = "makeBack"

    });
  });

  modelEls.forEach((li) => {
    li.addEventListener('click', () => {
      document.getElementById('acv-back-button').dataset.back == "initial"
      window.location.href = PCVehicleData.productUrl(li.dataset.value);
    });
  });
};



 const handleKeyboardNavigation = () => {
  const input = document.getElementById('acv-search');

  let focusedIndex = -1;

  input.addEventListener('keydown', (e) => {
    const items = dropdown.querySelectorAll('li.li-make, li.li-model');
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusedIndex = (focusedIndex + 1) % items.length;
      updateFocus(items, focusedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      focusedIndex = (focusedIndex - 1 + items.length) % items.length;
      updateFocus(items, focusedIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (focusedIndex >= 0 && items[focusedIndex]) {
        items[focusedIndex].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      input.value = '';
      dropdown.innerHTML = '';
      focusedIndex = -1; 
      acvState.selectedMake = '';

      const allMakes = window.makeModelData.map(entry => entry.make);
      const uniqueMakes = [...new Set(allMakes)];

      const bestSellerMakes = [];
      const normalMakes = [];

      uniqueMakes.forEach((make) => {
        if (getAllBestSellerMakes().has(make)) {
          bestSellerMakes.push(make);
        } else {
          normalMakes.push(make);
        }
      });

      appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
      appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
      handleMakeSelection();
    }
  });
};

const updateFocus = (items, index) => {
  items.forEach((item, i) => {
    if (i === index) {
      item.classList.add('focused');
      item.scrollIntoView({ block: 'nearest' });
    } else {
      item.classList.remove('focused');
    }
  });
};



    function toggleVisibility(element, isShow) {
      if (element) element.style.display = isShow ? "flex" : "none";
    }


document.getElementById('acv-back-button').addEventListener('click', () => {
  selectedNav.style.display = "none";
  let backType = document.getElementById('acv-back-button').dataset.back;

    if (backType === "initial") {
            toggleVisibility(document.querySelector(".c-hp-video-banner-content"), true);
            toggleVisibility(document.querySelector("#us-collection-selector"), true);
            toggleVisibility(document.querySelector("#acv-wrapper"), false);
            document.querySelector(".c-hp-video-banner-container").classList.remove("heightArrange");
            document.querySelector(".c-hp-video-banner-content-wrapper").style.justifyContent = "space between";


    } else if (backType === "makeBack") {

   
  acvState.selectedMake = '';
  document.getElementById('acv-search').value = '';
  dropdown.innerHTML = '';
  document.getElementById('acv-back-button').dataset.back = "initial"; 
  dropdown.style.pointerEvents = "auto";
  
  const allMakes = window.makeModelData.map(entry => entry.make);
  const uniqueMakes = [...new Set(allMakes)];

  const bestSellerMakes = [];
  const normalMakes = [];

  uniqueMakes.forEach((make) => {
    if (getAllBestSellerMakes().has(make)) {
      bestSellerMakes.push(make);
    } else {
      normalMakes.push(make);
    }
  });

  appendLiGroups(dropdown, 'Best Sellers', bestSellerMakes, 'make', 'li-make');
  appendLiGroups(dropdown, 'Other Makes', normalMakes, 'make', 'li-make');
  handleMakeSelection();
   } 
});




 const getClosestMatch = (query, list) => {
  let closest = '';
  let shortestDistance = Infinity;

  list.forEach(item => {
    const distance = levenshteinDistance(query.toLowerCase(), item.toLowerCase());
    if (distance < shortestDistance) {
      shortestDistance = distance;
      closest = item;
    }
  });

  return shortestDistance <= 3 ? closest : null; // çok uzaksa önermeyiz
};

const levenshteinDistance = (a, b) => {
  const matrix = Array.from({ length: a.length + 1 }, () => []);

  for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,    // deletion
        matrix[i][j - 1] + 1,    // insertion
        matrix[i - 1][j - 1] + cost // substitution
      );
    }
  }

  return matrix[a.length][b.length];
};


